<script>
/* INSTRUCTIONS:
    - This component file is meant to be a boilerplate template for building new components
    - Find and replace all references to 'componentTemplate' with your new component's name
    - Add editor configs to the editorSettings constant as you develop new features
    - Give your initial component a generic name
    - Put your template in cTemplate
    - Add controls (fields) using the controls property of your component and <control name="CONTROL_NAME"/> in your template
    - Import services or other components that you need using import statements
    - The component is initialized using componentStore.initComponent
    - After being initialized, it is visible in the list of components in your localhost devdash
    - After committing and a successful project build, the component will be available to all VUE architecture projects
        -- Warning: Configurations made to other components that utilize this component may not work in live environments until this component is committed
    - Delete these instructions in your new component when you no longer need them
    - For more information take a look https://samaritan.atlassian.net/wiki/spaces/DEVELOPMEN/pages/248447089/5+Component+Structure
    */
// import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import { uStore } from "@common/userStore";
import { configStore } from "@common/configStore";
// library - common functions inluding lodash, date/logic manipulation, dialogs etc.
// import { library } from "@common/library/library";
/*
    - check components/common folder for available stores e.g.
    - actionStore, controlStore, ddStore, recordStore
 */

const editorSettings = {
    /*
        - Settings, which can be modified through devDash
        - actually it is an object of controls for config editor
        -
     */
    /* color: {
        type: "dropdown",
        label: "Button color",
        default: "primary",
        fields: { text: 'text', value: 'value' },
        items: [
            { text: "Primary", value: "primary" },
            { text: "Warning", value: "warning" },
            { text: "Error", value: "danger" },
        ]
    } */
};

const componentTemplateConfig = {
    cId: "componentTemplate",
    cType: "componentTemplate",
    cTitle: "Core Component Template File",
    cTemplate: `<div>
        <div class="example-style">Component Template goes here.</div>

        Example of value of control in template: {{controls["SOME_SWITCH"].value}}<br/>
        <control name="SOME_SWITCH"></control>
        <div v-if="!controls['SOME_SWITCH'].value">This one will be removed from the dom, when Hide switch is checked</div>
        <div v-show="!controls['SOME_SWITCH'].value">This one will be hidden, when Hide switch is checked</div>
        <control name="SOME_BUTTON"></control>
        Example of using DataDictionary in template: {{ ddStoreFilter('DD.COMMON.BUTTON_APPLY') }}<br/>

        Example of using data/computed in template: <pre>{{user}}</pre>
    </div>`,
    /*
    cTemplate1: `<div>
        Component Template goes here.
        <component-id
            v-bind="someProperty" // v-bind should goes on the first place of attributes
            prop-prop-name="someProperty" @update:propName="someProperty = $event" // this should be used to synchronize property between components
            // prop- should be added if you want to pass property described in props section of child component
        ></component-id>
    </div>`,
    */
    // please check components/common/control/controlStore.js for available control types
    controls: [
        {
            name: 'SOME_SWITCH',
            type: 'boolean',
            label: 'Hide',
            onclick: 'buttonActionHide', // should be available in methods
            cssClass: ''
        },
        {
            name: 'SOME_BUTTON',
            type: 'button',
            // label: 'Button Label',
            label: 'DD.COMMON.BUTTON_APPLY', // Example of using DataDictionary in control config
            onclick: 'buttonAction', // should be available in methods
            cssClass: '',
        }
    ]
};

const componentTemplateCmp = {
    name: "componentTemplate",
    editorSettings: editorSettings,
    props: {
        /*
        * properties that can be passed as html attribute, e.g. <componentTemplate :prop-some-property="'testPropValue'"></componentTemplate>
        * default properties that automatically assigned through the componentStore.initComponent can be found in componentStore.js->componentGlobalMixins.props
        */
        someProperty: {
            type: String
        }
    },
    data() {
        return {
            user: false
        };
    },
    computed: {
        /*
        * - reactive data that mapped to the vuex stores or should be calculated on the fly
        * - default computed propeties can be found in componentStore.js->componentGlobalMixins.computed
        */
        configStoreExample() {
            return configStore.state.cfg;
        },
    },
    methods: {
        onCreate() {
            // called after component created ( Vue "created"  wrapper )
        },
        onUpdate() {
            // called each time, when the any property from data/props were updated ( Vue "updated"  wrapper )
        },
        onPropsUpdate() {
            // called each time, when the any property from props were updated
        },
        onMappedDataUpdate() {
            // called each time, when the any mapped data of component were updated
        },
        onLoad() {
            // called when the component settings were uploaded from the sDs and component ready for render
            uStore().getUserData().then((user) => {
                this.user = user;
            });
            /*
                call this.sDs.post('functionName', param1, param2) if you need to get some data from backend
                functionName can be found in common/config/sDs.inc file
            */
            // this.sDs.post('functionName', param1, param2)
        },
        manualSave() {
            // called when Apply/Finish button clicked in Profile VMS-8955
        },
        buttonAction() {
            // Perform some action
        }
    },
    components: {
        /*
            - other components that will be used in the template (e.g. <contact-card></contact-card>)
            - use lazy load:
        */
        // 'contactCard': defineAsyncComponent(() => import('@common/contactCard/contactCard.vue')),
    }
};
// componentStore.initComponent puts the component into the component store, makes the component available to other vue components, and adds it to the list of component options used in editors
componentStore.initComponent(componentTemplateCmp, componentTemplateConfig);

export { componentTemplateConfig, componentTemplateCmp };
export default componentTemplateCmp;
</script>

<style scoped>
    /*
    * Use scoped styles only
    * If component contains child components, you can change styles in there using :deep() ( e.g. :deep(.control) {margin: 10px;})
    */
    :deep(.example-style) {
        color: red;
    }
</style>
